import Model from '@/models/Model'

export default class GUser extends Model {

  static appends = ['ground_seller_id']
  static includes = ['hr_employee']

  get hr_employee_name_case() {
    return this.getProperty('hr_employee.name_case', '-')
  }

  get hr_employee_full_name() {
    return [
        this.hr_employee.names,
        this.hr_employee.last_name1,
        this.hr_employee.last_name2,
    ].join(' ')
  }

  resource() {
    return 'g_user'
  }
}
